import {useParams} from "react-router-dom";
import {useUserContext} from "../providers/UserContext";
import {Button, getButtonClassName} from "../components/common/Button";
import {useEffect, useState} from "react";
import {addChat, addMessage, viewGroup} from "../lib/database";
import { v4 as uuidv4 } from 'uuid';
import {Chat} from "../lib/types";
import {getFunctions, httpsCallable} from "firebase/functions";
import {Link} from "react-router-dom";
import {Icon} from "../components/common/Icon";
import {Empty} from "../components/illustrations/empty";
import classNames from "classnames";
import {UserPicker} from "../components/common/UserPicker";
import {UserName} from "../components/common/UserName";
import {ListItem} from "../components/chat/ListItem";
import {useInboxContext} from "../providers/InboxProvider";
import {List} from "../components/chat/List";
import {useChatListContext} from "../providers/ChatListProvider";
import {ChatPage} from "./Chat";
export const Inbox = ({}: {}) => {
  const { setActiveChatId } = useUserContext();
  const { inbox } = useInboxContext();
  const { setChatListSettings, setChatListVisible, setLoadChats,setCurrentFilter } = useChatListContext();
  const { chatId } = useParams();
  useEffect(() => {
    setCurrentFilter("inbox");
    setChatListSettings("Inbox", inbox, chatId || "");
    setLoadChats(() => inbox); // Pass the reference as a function
    setChatListVisible(true);
  }, [inbox]);

  useEffect(() => {
    setActiveChatId(chatId || "");
  }, [chatId, setActiveChatId]);
  let body = (
    <div className="flex flex-col gap-1 w-full h-full justify-center items-center">
      <div className="font-style-headline-1 flex items-center mt-[60px]">
        <span>
          Your chats
        </span>
      </div>
      <div className={"font-style-body-md text-gray-3 italic"}>
        This is your inbox, select a chat or start a new one.
      </div>
      <div className="actions flex gap-2 mt-4">
        <Link to={`/compose`} className={getButtonClassName()}>
          Compose
        </Link>
      </div>
    </div>
  );
  if (chatId) {
    body = <ChatPage />;
  }
  return body;
}